import React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Typography from "@mui/material/Typography";
import Logout from "@mui/icons-material/Logout";
import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import PersonIcon from "@mui/icons-material/Person";
import TuneIcon from "@mui/icons-material/Tune";
import ConnectedTvIcon from "@mui/icons-material/ConnectedTv";
import DriveFileMoveIcon from "@mui/icons-material/DriveFileMove";
import { useAuth } from "../../context/authContext";
import { useTheme } from "@emotion/react";
import { useThemeContext } from "../../context/themeContext";
import { useNavigate } from "react-router-dom";

export default function SettingsMenu({ anchorElement, open, onClose }) {
  const theme = useTheme();
  const navigate = useNavigate();
  const { toggleMode } = useThemeContext();
  const { logout, user } = useAuth();

  const handleProfileClick = () => {
    navigate("/settings/profile");
    onClose();
  };

  const handlePreferencesClick = () => {
    navigate("/settings/preferences");
    onClose();
  };

  const handleServicesClick = () => {
    navigate("/settings/services");
    onClose();
  };

  const handleImportClick = () => {
    navigate("/import");
    onClose();
  };

  return (
    <Menu
      anchorEl={anchorElement}
      id="account-menu"
      open={open}
      onClose={onClose}
      onClick={onClose} // ensures menu closes if non-button bit of menu is clicked
      MenuListProps={{ onMouseLeave: onClose }}
      transformOrigin={{ horizontal: "left", vertical: "bottom" }}
      anchorOrigin={{ horizontal: "left", vertical: "top" }}
    >
      <MenuItem onClick={handleProfileClick} disabled={!user}>
        <ListItemIcon>
          <PersonIcon fontSize="small" />
        </ListItemIcon>
        Profile
      </MenuItem>
      <MenuItem onClick={handlePreferencesClick} disabled={!user}>
        <ListItemIcon>
          <TuneIcon fontSize="small" />
        </ListItemIcon>
        Preferences
      </MenuItem>
      <MenuItem onClick={handleServicesClick} disabled={!user}>
        <ListItemIcon>
          <ConnectedTvIcon fontSize="small" />
        </ListItemIcon>
        Services
      </MenuItem>
      <MenuItem onClick={handleImportClick} disabled={!user}>
        <ListItemIcon>
          <DriveFileMoveIcon fontSize="small" />
        </ListItemIcon>
        Import
      </MenuItem>
      <MenuItem onClick={toggleMode}>
        <ListItemIcon>
          {theme.palette.mode === "dark" ? (
            <LightModeIcon fontSize="small" />
          ) : (
            <DarkModeIcon fontSize="small" />
          )}
        </ListItemIcon>
        {theme.palette.mode === "dark" ? "Light mode" : "Dark mode"}
      </MenuItem>
      {user && (
        <MenuItem onClick={() => logout("You have successfully logged out")}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      )}
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ display: "block", textAlign: "right", py: 0, pr: 2 }}
      >
        v{process.env.REACT_APP_VERSION || "dev"}
      </Typography>
    </Menu>
  );
}
